import request from "../../utils/request";

export function getPersonnelList(params) {
  return request({
    url: "/personnel",
    method: "get",
    params
  });
}

export function getPersonnelFilterOptions() {
  return request({
    url: "/personnel/filter-options",
    method: "get"
  });
}

export function createPersonnel(data) {
  return request({
    url: "/personnel",
    method: "post",
    data
  });
}

export function getPersonnelDetail(id) {
  return request({
    url: `/personnel/${id}`,
    method: "get"
  });
}

export function getBindQr() {
  return request({
    url: "/personnel/bind/qr",
    method: "post"
  });
}

export function savePrompt(id, data) {
  return request({
    url: `/personnel/${id}/prompt`,
    method: "put",
    data
  });
}

export function verifyPrompt(id, data) {
  return request({
    url: `/personnel/${id}/prompt/verify`,
    method: "post",
    data
  });
}

export function unbindPersonnel(id) {
  return request({
    url: `/personnel/${id}`,
    method: "delete"
  });
}

export function updatePersonnel(id, data) {
  return request({
    url: `/personnel/${id}`,
    method: "put",
    data
  });
}

export function sendPersonnelTestMessage(id, data) {
  return request({
    url: `/personnel/${id}/send-test-message`,
    method: "post",
    data
  });
}

export function updatePersonnelAiSwitch(id, data) {
  return request({
    url: `/personnel/${id}/ai-switch`,
    method: "put",
    data
  });
}

export function batchUpdatePersonnelAiSwitch(data) {
  return request({
    url: "/personnel/ai-switch/batch",
    method: "put",
    data
  });
}

export function batchUpdatePersonnelAiSwitchSchedule(data) {
  return request({
    url: "/personnel/ai-switch-schedule/batch",
    method: "put",
    data
  });
}

export function getPersonnelAiSwitchLogs(id, params) {
  return request({
    url: `/personnel/${id}/ai-switch-logs`,
    method: "get",
    params
  });
}

export function getPersonnelPassword(id) {
  return request({
    url: `/personnel/${id}/password`,
    method: "get"
  });
}

export function updatePersonnelPassword(id, data) {
  return request({
    url: `/personnel/${id}/password`,
    method: "put",
    data
  });
}
